<template>
  <div class="content">
    <header class="header">
      <p class="user-info">您要儲值的帳號為:{{ userName }}</p>
      <p class="recharge-instructions">
        請選擇儲值金額
        <span v-if="type == 1">（1點 = 1新台幣）</span>
      </p>
      <ul>
        <li
          class="order-list"
          v-for="(item, index) in orderList"
          :key="index"
          @click="createOrder(item.app_id, index)"
        >
          <a>
            <div class="detail">
              <div class="detail-left">
                <img
                  src="./order_img/coin2.png"
                  width="25"
                  height="25"
                  alt=""
                />
                <span>{{ item.qty }}鑽石</span>
              </div>
              <!-- <div class="detail-center">
                                <p class="rebate">返利</p>
                                <p class="rebate-text" style="margin-top:3px">+750唱点</p>
                                <p class="rebate-text">+150唱豆</p>
                            </div> -->
              <div class="detail-right">
                <span v-if="type == 1">Mycard&nbsp;</span>
                {{ item.price }}{{ item.unit }}
                <i class="iconfont icon-youjiantou" style="color: #ccc"></i>
              </div>
              <div
                v-if="item.channel == 'GOOGLEPAY' && item.price == '1'"
                class="bage"
                style="width: auto; min-width: 40px"
              >
                限時
              </div>
            </div>
          </a>
        </li>
      </ul>
    </header>
  </div>
</template>

<script>
import Qs from 'qs'
import { Base64 } from 'js-base64'
export default {
  name: 'order',
  data () {
    return {
      userInfo: '',
      userName: '',
      type: 1,
      uid: '',
      orderList: [],
    }
  },
  mounted () {
    this.orderList = JSON.parse(decodeURIComponent(this.$route.query.datalist))
    this.userInfo = JSON.parse(decodeURIComponent(this.$route.query.userInfo))
    this.type = this.$route.query.type
    this.userName = this.userInfo.data.nickname
    this.uid = this.userInfo.data.uid
    // console.log(this.type);
    // console.log(this.$route.query.userInfo)
    // console.log(this.$route.query.datalist)
  },
  methods: {
    //判断是否是app内打开
    isHappyTalk () {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/happytalk/i) == 'happytalk') {
        return true;
      } else {
        return false;
      }
    },
    createOrder (appId, index) {
      // console.log(appId,this.uid)
      if (this.type == 1) {
        this.$axios
          .get(
            `../api/api1.php?c=commodity._createMycardPay&app_id=${appId}&type=1&uid=${this.uid}`
          )
          .then(res => {
            console.log(res)
            if (res.data.code == 1) {
              alert(res.data.data.ReturnMsg)
            }

            if (res.data.code == 0) {
              const auth_code = res.data.data.auth_code
              if(process.env.VUE_APP_ENV == 'staging'){
                // 测试
                window.location.href = `http://test.mycard520.com.tw/MyCardPay?AuthCode=${auth_code}`
              }else{
                // 正式
                window.location.href = `https://www.mycard520.com.tw/MyCardPay?AuthCode=${auth_code}`
              }
            }
          })
      } else if (this.type == 2) {
        this.$axios
          .get(
            `../api/api1.php?c=commodity._createiPassPay&app_id=${appId}&type=1&uid=${this.uid}`
          )
          .then(res => {
            console.log(res)
            if (res.data.code == 1) {
              alert(res.data.data.ReturnMsg)
            }
            if (res.data.code == 0) {
              window.location.href = res.data.data.pay_url
            }
          })
      } else if (this.type == 5) {
        this.$axios
          .get(
            `../api/api1.php?c=commodity._createOmgPay&app_id=${appId}&type=1&uid=${this.uid}`
          )
          .then(res => {
            if (res.data.code == 1) {
              alert(res.data.data.ReturnMsg)
            }
            if (res.data.code == 0) {
              this.postOpenWindow(res.data.url, res.data.data)
            }
          })
      } else if (this.type == 8) {
        this.$axios
          .get(
            `../api/api1.php?c=commodity._createAirsecurecardPay&app_id=${appId}&type=1&uid=${this.uid}&bill_firstname=jenny&bill_lastname=Schecter&bill_email=tech-agent3@airsecurecard.com`
          )
          .then(res => {
            console.log(res)
            if (res.data.code == 1) {
              alert(res.data.data.ReturnMsg)
            }
            if (res.data.code == 0) {
              window.location.href = decodeURIComponent(res.data.data.pay_url)
            }
          })
      } else if (this.type == 11 || this.type == 13) {
        let isCurChannel = this.type == 13 ? 'APPLEPAY' : 'GOOGLEPAY'
        this.$axios
          .get(
            `../api/api1.php?c=commodity._createPayermaxPayByChannel&app_id=${appId}&type=1&channel=${isCurChannel}&uid=${this.uid}`
          )
          .then(res => {
            console.log(res)
            if (res.data.code == 1) {
              alert(res.data.data.ReturnMsg)
            }
            if (res.data.code == 0) {
              console.log(res.data.data)
              window.location.href = res.data.data.pay_url
              // const urlStr = res.data.data.pay_url
              // if (this.isHappyTalk()) {
              //   const urlBase64 = Base64.encode(urlStr)
              //   window.location.href = 'happytalk://happytalk.app/OpenExternalLinks?url=' + urlBase64
              // } else {
              //   window.location.href = urlStr
              // }
            }
          })
      } else if(this.type == 15){
        this.$axios
          .get(
            `../api/api1.php?c=commodity._createHuitech&type=1&app_id=${appId}&uid=${this.uid}`
          )
          .then(res => {
            console.log(res)
            if (res.data.code == 0) {
              const orderParams = {
                ...res.data.data,
                ...this.orderList[index]
              }
              console.log(orderParams)
              this.$router.push({
                path: 'weChatQrCodePay',
                query: { orderParams: Base64.encode(JSON.stringify(orderParams))},
              })
            }else{
              alert(res.data.message)
            }
          })
      }
      else {
        this.$axios
          .get(
            `../api/api1.php?c=commodity._createPayermaxPay&app_id=${appId}&type=1&uid=${this.uid}`
          )
          .then(res => {
            console.log(res)
            if (res.data.code == 1) {
              alert(res.data.data.ReturnMsg)
            }
            if (res.data.code == 0) {
              window.location.href = res.data.data.pay_url
            }
          })
      }
    },
    postOpenWindow (URL, PARAMS) {
      var temp_form = document.createElement('form')
      temp_form.action = URL
      temp_form.method = 'post'
      temp_form.style.display = 'none'
      for (var x in PARAMS) {
        var opt = document.createElement('textarea')
        opt.name = x
        opt.value = PARAMS[x]
        temp_form.appendChild(opt)
      }
      document.body.appendChild(temp_form)
      temp_form.submit()
      document.body.removeChild(temp_form)
    },
  },
}
</script>

<style lang="stylus" scoped>
.content {
  width: 90%;
  min-height: 100vh;
  background: #fff;
  margin: 0 auto;

  .header {
    .user-info {
      width: 100%;
      height: 42px;
      line-height: 42px;
      text-align: center;
    }

    .recharge-instructions {
      border-left: 5px solid #f64d5d;
      padding-left: 20px;
      width: 100%;
      height: 42px;
      line-height: 42px;
      background-color: #ebebeb;
      color: #696969;
      font-size: 14px;
    }

    ul {
      .order-list {
        width: 100%;
        height: 66px;
        border-bottom: 1px solid #dee2e6;
        cursor: pointer;

        :hover {
          background: #FFFEC9;
        }

        .detail {
          // width:95%
          height: 66px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          position: relative;

          .detail-left {
            margin-left: 10px;

            img {
              vertical-align: top;
            }

            span {
              font-size: 73%;
              color: #343a40;
              font-family: 'Microsoft JhengHei';
              margin-left: 5px;
              line-height: 21px;
            }
          }

          .detail-center {
            flex: 1;
            margin-left: 6px;

            .rebate {
              width: 28px;
              height: 13px;
              font-size: 8px;
              color: #fff;
              line-height: 13px;
              text-align: center;
              background-color: #ff4040;
              border-radius: 4px;
            }

            .rebate-text {
              color: #ff4040;
              font-size: 12px;
              line-height: 15px;
            }
          }

          .detail-right {
            position: absolute;
            right: 0;
            color: #52c5a0;
            font-size: 12px;
          }

          .bage {
            font-size: 10px;
            color: #fff;
            background: #ec3238;
            position: absolute;
            top: 0;
            right: 0;
            height: 20px;
            line-height: 20px;
            text-align: center;
            border-radius: 0 0 0 4px;
            // border: 1px solid #fd178a;
            // font-size: 14px;
            // color: #E800F4;
            // background-color #fff
          }
        }
      }
    }
  }
}
</style>
